@if (validateDict?.is_validated) {
<span class="tooltips" appFocus>
    @if (validateDict?.training_completed) {
    <svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
        class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
        <title>Training completed</title>
        <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
    }
    @if(!validateDict?.training_completed) {
    <svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
        class="bi bi-check-circle-fill  partially-completed" viewBox="0 0 17 19">
        <title>Partially completed</title>
        <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
    }
    <span [ngClass]="from == 'bookingSideInviteList' ? 'tooltiptextSideInvite' : 'tooltiptext'" class="">
        <p class="mb-10">Verified with NSW Department of Education</p>
        <div class="mb-3  d-flex align-items-center">
            <span><svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
                    class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
                    <title>Approval to teach</title>
                    <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
            </span>
            <span class="mt-3 ml-3"> Approval to teach </span>
        </div>
        @if (!validateDict?.training_completed) {
        <div class="mb-5  d-flex align-items-center">
            <span><svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
                    class="bi bi-x-circle-fill mandatory-not-completed" viewBox="0 0 17 19">
                    <title>Mandatory training incomplete</title>
                    <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                </svg> </span>
            <span class="mt-3 ml-3"> Mandatory Training Completed </span>
        </div>
        }
        @if (validateDict?.training_completed) {
        <div class="mb-5   d-flex align-items-center">
            <span><svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
                    class="bi bi-check-circle-fill  check-completed" viewBox="0 0 17 19">
                    <title>Mandatory training completed</title>
                    <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg></span>
            <span class="mt-3 ml-3"> Mandatory Training Completed</span>
        </div>
        }
        <p class="mt-10">Find out more <a role="button" appFocus appClick
                href="https://intercom.help/classcover-support/en/articles/4669343-what-does-the-verification-symbol-next-to-a-teacher-s-name-mean-nsw-only"
                target="_blank">here</a></p>
    </span>
</span>
}@else if(!validateDict?.is_validated && from == 'teacherProfile' && validateDict?.is_matched) {
<span class="tooltips" appFocus>
    <svg role="img" xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor"
        class="bi bi-check-circle-fill  doe-not-verified" viewBox="0 0 17 19">
        <title>Partially completed</title>
        <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
    <span [ngClass]="from == 'bookingSideInviteList' ? 'tooltiptextSideInvite' : 'tooltiptext'" class="">
        <p class="mb-10">Not Verified</p>
        <div class="mb-3  d-flex align-items-center">
            Not matched with Department Of Education <br>
            Not approved to teach
        </div>
        <p class="mt-10">Find out more <a role="button" appFocus appClick
                href="https://intercom.help/classcover-support/en/articles/4537730-not-verified-on-classcover-not-matched-nsw-only"
                target="_blank">here</a></p>
    </span>
</span>
}